
// import React, { useState, useEffect } from "react";
// import Navbar from "../../../Patient/components/pages/Navbar";
// import { Container } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faSearch, faMapMarkerAlt, faCalendarAlt,
//   faSun, faMoon, faClock, faChevronDown, faChevronUp,
//   faImages, faVideo, faCommentMedical, faTimes, faChevronLeft, faChevronRight,
//   faIndianRupeeSign,
// } from "@fortawesome/free-solid-svg-icons";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import profile from "./image/dp.png";
// import "./SearchDoctor.css";
// import Footer from "../../../Footer/Footer";
// import BookingModal from "./BookingModal";
// import { getDatabase, ref, get } from "firebase/database";
// import { app } from "../../../Doctor/Firebase/firebase.config";
// import SpecialityAutosuggest from "../pages/Register/SpecialityAutosuggest";

// const database = getDatabase(app);

// const normalizeCity = (text = "") => text.toLowerCase().split(",")[0].trim();

// const formatTime = (t) => {
//   if (!t) return "";
//   try {
//     const [h, m] = t.split(":").map(Number);
//     const ampm = h >= 12 ? "PM" : "AM";
//     return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${ampm}`;
//   } catch { return t; }
// };

// const getConsultationFee = (doctor) => {
//   const stored = doctor.Fees ?? doctor.fees ?? doctor.Fee ?? doctor.ConsultationFee ?? null;
//   if (stored !== null && stored !== undefined && stored !== "") return Number(stored);
//   return null; // no fee set — show NA
// };

// // Doctor records in Firebase use "City" and "Address" rather than
// // "Locality" / "ClinicAddress" in some entries. These helpers read
// // whichever field actually exists so search + map both work.
// const getCity = (d) => d.Locality || d.City || "";
// const getAddress = (d) => d.ClinicAddress || d.Address || "";

// /* ── Clinic Photos Modal ── */
// function ClinicPhotosModal({ photos, doctorName, onClose }) {
//   const [current, setCurrent] = useState(0);
//   const prev = () => setCurrent((c) => (c - 1 + photos.length) % photos.length);
//   const next = () => setCurrent((c) => (c + 1) % photos.length);

//   useEffect(() => {
//     const handleKey = (e) => {
//       if (e.key === "Escape") onClose();
//       if (e.key === "ArrowLeft") prev();
//       if (e.key === "ArrowRight") next();
//     };
//     document.addEventListener("keydown", handleKey);
//     return () => document.removeEventListener("keydown", handleKey);
//   }, []);

//   return (
//     <div className="photo-modal-overlay" onClick={onClose}>
//       <div className="photo-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="photo-modal-header">
//           <h3 className="photo-modal-title">
//             <FontAwesomeIcon icon={faImages} /> Clinic Photos — Dr. {doctorName}
//           </h3>
//           <button className="photo-modal-close" onClick={onClose}>
//             <FontAwesomeIcon icon={faTimes} />
//           </button>
//         </div>
//         <div className="photo-modal-body">
//           <div className="photo-main-wrap">
//             <button className="photo-nav-btn left" onClick={prev}>
//               <FontAwesomeIcon icon={faChevronLeft} />
//             </button>
//             <img src={photos[current]} alt={`Clinic photo ${current + 1}`} className="photo-main-img" />
//             <button className="photo-nav-btn right" onClick={next}>
//               <FontAwesomeIcon icon={faChevronRight} />
//             </button>
//           </div>
//           <p className="photo-counter">{current + 1} / {photos.length}</p>
//           {photos.length > 1 && (
//             <div className="photo-thumbnails">
//               {photos.map((src, i) => (
//                 <img key={i} src={src} alt={`Thumb ${i + 1}`}
//                   className={`photo-thumb${i === current ? " active" : ""}`}
//                   onClick={() => setCurrent(i)} />
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ── Timing strip ── */
// function TimingStrip({ schedule }) {
//   if (!schedule) return (
//     <div className="timing-strip">
//       <span className="timing-chip no-schedule">
//         <FontAwesomeIcon icon={faClock} size="xs" /> Schedule not set
//       </span>
//     </div>
//   );
//   const hasMorning = schedule.morningStartTime && schedule.morningEndTime;
//   const hasEvening = schedule.eveningStartTime && schedule.eveningEndTime;
//   if (!hasMorning && !hasEvening) return (
//     <div className="timing-strip">
//       <span className="timing-chip no-schedule">
//         <FontAwesomeIcon icon={faClock} size="xs" /> Timings not set
//       </span>
//     </div>
//   );
//   return (
//     <div className="timing-strip">
//       {hasMorning && (
//         <span className="timing-chip morning">
//           <FontAwesomeIcon icon={faSun} size="xs" />
//           {formatTime(schedule.morningStartTime)} – {formatTime(schedule.morningEndTime)}
//         </span>
//       )}
//       {hasEvening && (
//         <span className="timing-chip evening">
//           <FontAwesomeIcon icon={faMoon} size="xs" />
//           {formatTime(schedule.eveningStartTime)} – {formatTime(schedule.eveningEndTime)}
//         </span>
//       )}
//     </div>
//   );
// }

// /* ── Doctor Card ── */
// function DoctorCard({ doctor, schedule, clinicPhotos = [], onMap, onBook, isMapOpen }) {
//   const [expanded, setExpanded] = useState(false);
//   const [showPhotosModal, setShowPhotosModal] = useState(false);

//   const videoLink = doctor.videoLink || doctor.VideoLink || null;
//   const hasPhotos = clinicPhotos.length > 0;
//   const hasVideo = !!videoLink;

//   const fee = getConsultationFee(doctor); // null means not set by doctor
//   const address = getAddress(doctor);

//   const handleVideoClick = () => {
//     if (hasVideo) window.open(videoLink, "_blank", "noopener,noreferrer");
//   };

//   const handleChatClick = () => {
//     toast.info("💬 Chat with Doctor — Coming Soon!", {
//       position: "top-center", autoClose: 3000, hideProgressBar: false,
//       style: { fontFamily: "'Nunito', sans-serif", fontWeight: 600 },
//     });
//   };

//   return (
//     <div className="doctor-card">
//       <div className="card-top-bar" />
//       <div className="card-inner">
//         <div className="card-left">
//           <img src={doctor.imageUrl || profile} alt={`Dr. ${doctor.First}`} className="doctor-avatar" />
//         </div>
//         <div className="card-content">
//           <div className="doctor-name">Dr. {doctor.First} {doctor.Last}</div>
//           <TimingStrip schedule={schedule} />
//           <div className="info-list">
//             {doctor.Speciality && (
//               <div className="info-item">
//                 <span className="info-label">Speciality</span>
//                 <span className="info-value">{doctor.Speciality}</span>
//               </div>
//             )}
//             <div className="info-item fee-info-item">
//               <span className="info-label">Fees</span>
//               <span className="fee-inline">
//                 {fee !== null ? (
//                   <>
//                     <FontAwesomeIcon icon={faIndianRupeeSign} className="fee-inline-icon" />
//                     <span className="fee-inline-amount">{fee}</span>
//                   </>
//                 ) : (
//                   <span className="fee-inline-na">NA</span>
//                 )}
//               </span>
//             </div>
//             {doctor.Education && (
//               <div className="info-item">
//                 <span className="info-label">Education</span>
//                 <span className="info-value">{doctor.Education}</span>
//               </div>
//             )}
//             {doctor.Experience && (
//               <div className="info-item">
//                 <span className="info-label">Experience</span>
//                 <span className="info-value">{doctor.Experience} years</span>
//               </div>
//             )}
//             {doctor.ClinicName && (
//               <div className="info-item">
//                 <span className="info-label">Clinic</span>
//                 <span className="info-value">{doctor.ClinicName}</span>
//               </div>
//             )}
//             {address && (
//               <div className="info-item">
//                 <span className="info-label">Address</span>
//                 <span className="info-value">{address}</span>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {doctor.Description && (
//         <div className="doctor-description-section">
//           <p className={`desc-text${expanded ? " expanded" : ""}`}>{doctor.Description}</p>
//           <button className="read-more-btn" onClick={() => setExpanded(!expanded)}>
//             <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} size="xs" />
//             {expanded ? "Show less" : "Read more"}
//           </button>
//         </div>
//       )}

//       <div className="extra-info-row">
//         <div className="extra-info-item">
//           <span className="extra-info-label">
//             <FontAwesomeIcon icon={faImages} className="extra-icon" /> Clinic Photos
//           </span>
//           {hasPhotos ? (
//             <button className="extra-info-action photos-btn" onClick={() => setShowPhotosModal(true)}>
//               View Photos ({clinicPhotos.length})
//             </button>
//           ) : (
//             <span className="extra-info-dash">—</span>
//           )}
//         </div>
//         <div className="extra-info-item">
//           <span className="extra-info-label">
//             <FontAwesomeIcon icon={faVideo} className="extra-icon" /> Video Link
//           </span>
//           {hasVideo ? (
//             <button className="extra-info-action video-btn" onClick={handleVideoClick}>Watch Video</button>
//           ) : (
//             <span className="extra-info-dash">—</span>
//           )}
//         </div>
//         <div className="extra-info-item">
//           <span className="extra-info-label">
//             <FontAwesomeIcon icon={faCommentMedical} className="extra-icon" /> Chat
//           </span>
//           <button className="extra-info-action chat-btn" onClick={handleChatClick}>Chat Soon</button>
//         </div>
//       </div>

//       <div className="card-actions">
//         <button className="btn-map" onClick={() => onMap(doctor)}>
//           <FontAwesomeIcon icon={faMapMarkerAlt} /> View Map
//         </button>
//         <button className="btn-book" onClick={() => onBook(doctor)}>
//           <FontAwesomeIcon icon={faCalendarAlt} /> Book Appointment
//         </button>
//       </div>

//       {isMapOpen && <div id={`map-${doctor.id}`} className="doctor-map" />}

//       {showPhotosModal && hasPhotos && (
//         <ClinicPhotosModal
//           photos={clinicPhotos}
//           doctorName={`${doctor.First} ${doctor.Last}`}
//           onClose={() => setShowPhotosModal(false)}
//         />
//       )}
//     </div>
//   );
// }

// /* ── Main ── */
// export default function SearchDoctor() {
//   const [doctors, setDoctors] = useState([]);
//   const [locality, setLocality] = useState("");
//   const [doctorName, setDoctorName] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [searched, setSearched] = useState(false);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);
//   const [mapLoaded, setMapLoaded] = useState(false);
//   const [showBookingModal, setShowBookingModal] = useState(false);
//   const [bookingDoctor, setBookingDoctor] = useState(null);
//   const [doctorSchedules, setDoctorSchedules] = useState({});
//   const [doctorClinicPhotos, setDoctorClinicPhotos] = useState({});

//   // ── Load Google Maps ──
//   useEffect(() => {
//     if (window.google?.maps) { setMapLoaded(true); return; }
//     const s = document.createElement("script");
//     s.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&loading=async`;
//     s.async = true; s.defer = true;
//     s.onload = () => setMapLoaded(true);
//     s.onerror = () => toast.error("Google Maps failed to load");
//     document.head.appendChild(s);
//   }, []);

//   // ── Init Places Autocomplete ──
//   useEffect(() => {
//     if (!mapLoaded) return;
//     let retry;
//     const init = () => {
//       if (window.google?.maps?.places) {
//         const input = document.getElementById("locality-input");
//         if (!input) return;
//         const ac = new window.google.maps.places.Autocomplete(input, {
//           types: ["(cities)"], componentRestrictions: { country: "in" },
//         });
//         ac.addListener("place_changed", () => {
//           const p = ac.getPlace();
//           setLocality(p.formatted_address || p.name || "");
//         });
//       } else { retry = setTimeout(init, 100); }
//     };
//     init();
//     return () => clearTimeout(retry);
//   }, [mapLoaded]);

//   // ── Read URL params from home page search and auto-trigger search ──
//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const searchParam = params.get("search") || "";
//     const cityParam = params.get("city") || "";

//     if (searchParam) setDoctorName(searchParam);
//     if (cityParam) setLocality(cityParam);

//     if (searchParam || cityParam) {
//       setTimeout(() => {
//         runSearch(searchParam, cityParam);
//       }, 300);
//     }
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const fetchDoctorSchedules = async (ids) => {
//     const schedules = {};
//     for (const id of ids) {
//       try {
//         const snap = await get(ref(database, `doctor/${id}/schedule`));
//         if (snap.exists()) {
//           const data = snap.val();
//           const key = Object.keys(data)[0];
//           if (key) schedules[id] = data[key];
//         }
//       } catch (e) { console.error(e); }
//     }
//     setDoctorSchedules(schedules);
//   };

//   const fetchDoctorClinicPhotos = async (ids) => {
//     const photos = {};
//     for (const id of ids) {
//       try {
//         const snap = await get(ref(database, `Profile/${id}/Clinic`));
//         if (snap.exists()) {
//           const data = snap.val();
//           const images = Array.isArray(data.images) ? data.images : Object.values(data.images || {});
//           if (images.length > 0) photos[id] = images.filter(Boolean);
//         }
//       } catch (e) { console.error(e); }
//     }
//     setDoctorClinicPhotos(photos);
//   };

//   // ── Core search logic ──
//   // FIX: Wrapped all field comparisons with String() to prevent
//   // "toLowerCase is not a function" when Firebase returns non-string values.
//   // FIX: Doctor records store city/address under "City"/"Address" in some
//   // entries and "Locality"/"ClinicAddress" in others — getCity()/getAddress()
//   // check both so search works regardless of which field a record uses.
//   const runSearch = async (nameOverride, cityOverride) => {
//     const searchName = (nameOverride ?? doctorName).trim().toLowerCase();
//     const searchCity = normalizeCity(cityOverride ?? locality);
//     if (!searchName && !searchCity) {
//       toast.warning("Please enter a doctor name or city"); return;
//     }
//     try {
//       setLoading(true); setSearched(true);
//       const snap = await get(ref(database, "doctor"));
//       if (!snap.exists()) { setDoctors([]); return; }
//       const all = Object.entries(snap.val()).map(([id, v]) => ({ id, ...v }));

//       const filtered = all.filter((d) => {
//         const address = getAddress(d);
//         const city = getCity(d);

//         const nameMatch = !searchName ||
//           String(d.First || "").toLowerCase().includes(searchName) ||
//           String(d.Last || "").toLowerCase().includes(searchName) ||
//           String(d.Speciality || "").toLowerCase().includes(searchName) ||
//           String(d.ClinicName || "").toLowerCase().includes(searchName) ||
//           String(address).toLowerCase().includes(searchName);

//         const locMatch = !searchCity ||
//           normalizeCity(String(city)).includes(searchCity) ||
//           String(address).toLowerCase().includes(searchCity);

//         return nameMatch && locMatch;
//       });
//       if (filtered.length) {
//         const ids = filtered.map((d) => d.id);
//         const profileUrls = {};
//         for (const id of ids) {
//           try {
//             const pSnap = await get(ref(database, `Profile/${id}/Profile/base64`));
//             if (pSnap.exists()) profileUrls[id] = pSnap.val();
//           } catch (e) { console.error(e); }
//         }
//         const withPhotos = filtered.map((d) => ({
//           ...d,
//           imageUrl: profileUrls[d.id] || d.imageUrl || null,
//         }));
//         setDoctors(withPhotos);
//         fetchDoctorSchedules(ids);
//         fetchDoctorClinicPhotos(ids);
//       } else {
//         setDoctors(filtered);
//       }
//     } catch (e) {
//       console.error(e); toast.error("Failed to fetch doctors");
//     } finally { setLoading(false); }
//   };

//   const fetchDoctors = () => runSearch(doctorName, locality);

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") { e.preventDefault(); fetchDoctors(); }
//   };

//   const handleSpecialitySelect = (name) => {
//     setDoctorName(name);
//     setTimeout(() => runSearch(name, locality), 0);
//   };

//   const showDoctorOnMap = (doctor) => {
//     if (!mapLoaded) { toast.error("Map still loading"); return; }
//     const isAlready = selectedDoctor?.id === doctor.id;
//     setSelectedDoctor(isAlready ? null : doctor);
//     if (isAlready) return;
//     setTimeout(() => {
//       const mapDiv = document.getElementById(`map-${doctor.id}`);
//       if (!mapDiv) return;
//       const geocoder = new window.google.maps.Geocoder();
//       // FIX: use getAddress()/getCity() so geocoding works whether the
//       // record stores Address/City or ClinicAddress/Locality.
//       geocoder.geocode(
//         { address: `${getAddress(doctor)}, ${getCity(doctor)}` },
//         (results, status) => {
//           if (status !== "OK" || !results[0]) { toast.error("Location not found"); return; }
//           const map = new window.google.maps.Map(mapDiv, { center: results[0].geometry.location, zoom: 15 });
//           new window.google.maps.Marker({
//             map, position: results[0].geometry.location,
//             title: `Dr. ${doctor.First} ${doctor.Last}`,
//           });
//         }
//       );
//     }, 150);
//   };

//   const handleBookAppointment = (doctor) => { setBookingDoctor(doctor); setShowBookingModal(true); };
//   const handleCloseBookingModal = () => { setShowBookingModal(false); setBookingDoctor(null); };

//   return (
//     <>
//       <Navbar />
//       <Container fluid className="search-doctor-container">
//         <ToastContainer position="top-right" autoClose={3000} />

//         <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
//           <span className="cs-label">
//             <span className="cs-star">✦</span>
//             Coming Soon
//             <span className="cs-star">✦</span>
//           </span>
//           <p style={{ marginTop: "0.5rem", color: "#64748b", fontSize: "0.88rem" }}>
//             More doctors &amp; specialities expanding to your city soon!
//           </p>
//         </div>

//         {/* ── Two-block search row ── */}
//         <div className="search-row" style={{ position: "relative" }}>

//           {/* Block 1 — City with Google Autocomplete */}
//           <div className="search-block">
//             <label className="search-block-label">
//               <FontAwesomeIcon icon={faMapMarkerAlt} /> City
//             </label>
//             <input
//               id="locality-input"
//               className="form-control search-block-input"
//               type="text"
//               placeholder="Enter city..."
//               value={locality}
//               onChange={(e) => setLocality(e.target.value)}
//               onKeyDown={handleKeyDown}
//             />
//           </div>

//           <div className="search-block-divider" />

//           {/* Block 2 — Doctor / Speciality */}
//           <div className="search-block search-block--flex">
//             <label className="search-block-label">
//               <FontAwesomeIcon icon={faSearch} /> Doctor / Speciality
//             </label>
//             <SpecialityAutosuggest
//               value={doctorName}
//               onChange={(e) => setDoctorName(e.target.value)}
//               onSelect={handleSpecialitySelect}
//               onSearch={fetchDoctors}
//               placeholder="Doctor name, speciality, clinic..."
//             />
//           </div>

//           <button className="search-btn" onClick={fetchDoctors}>
//             <FontAwesomeIcon icon={faSearch} /> Search
//           </button>
//         </div>

//         {/* Search row styles */}
//         <style>{`
//           .search-row {
//             display: flex;
//             align-items: center;
//             background: #fff;
//             border: 1.5px solid #d1dff0;
//             border-radius: 50px;
//             padding: 6px 8px 6px 16px;
//             box-shadow: 0 2px 12px rgba(74,144,217,0.10);
//             gap: 0;
//             max-width: 700px;
//             margin: 0 auto 2rem;
//           }
//           .search-block {
//             display: flex;
//             flex-direction: column;
//             flex: 1;
//             min-width: 0;
//             padding: 2px 8px;
//           }
//           .search-block--flex {
//             flex: 2;
//           }
//           .search-block-label {
//             font-size: 0.68rem;
//             font-weight: 700;
//             color: #4a90d9;
//             letter-spacing: 0.04em;
//             text-transform: uppercase;
//             margin-bottom: 2px;
//           }
//           .search-block-input {
//             border: none !important;
//             outline: none !important;
//             box-shadow: none !important;
//             padding: 0 !important;
//             font-size: 0.9rem;
//             color: #1e293b;
//             background: transparent !important;
//             height: auto !important;
//           }
//           .search-block-input::placeholder { color: #94a3b8; }
//           .search-block-divider {
//             width: 1px;
//             height: 36px;
//             background: #e2eaf4;
//             flex-shrink: 0;
//             align-self: center;
//           }
//           .pac-container { z-index: 99999 !important; }
//           @media (max-width: 600px) {
//             .search-row {
//               flex-direction: column;
//               border-radius: 16px;
//               padding: 12px;
//               gap: 8px;
//             }
//             .search-block-divider { width: 100%; height: 1px; }
//             .search-btn { border-radius: 12px !important; width: 100%; justify-content: center; }
//           }
//         `}</style>

//         {loading ? (
//           <p className="status-msg">Looking up doctors…</p>
//         ) : searched && doctors.length === 0 ? (
//           <div className="coming-soon-banner">
//             <p>No doctors found in this area yet. We're expanding — check back soon!</p>
//           </div>
//         ) : !searched ? (
//           <div className="coming-soon-banner">
//             <p>Search for doctors by city or speciality above.</p>
//           </div>
//         ) : (
//           <div className="doctors-grid">
//             {doctors.map((doctor) => (
//               <DoctorCard
//                 key={doctor.id}
//                 doctor={doctor}
//                 schedule={doctorSchedules[doctor.id] || null}
//                 clinicPhotos={doctorClinicPhotos[doctor.id] || []}
//                 onMap={showDoctorOnMap}
//                 onBook={handleBookAppointment}
//                 isMapOpen={selectedDoctor?.id === doctor.id}
//               />
//             ))}
//           </div>
//         )}
//       </Container>

//       {bookingDoctor && (
//         <BookingModal
//           show={showBookingModal}
//           handleClose={handleCloseBookingModal}
//           doctor={bookingDoctor}
//         />
//       )}
//       <Footer />
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import Navbar from "../../../Patient/components/pages/Navbar";
import { Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch, faMapMarkerAlt, faCalendarAlt,
  faSun, faMoon, faClock, faChevronDown, faChevronUp,
  faImages, faVideo, faCommentMedical, faTimes, faChevronLeft, faChevronRight,
  faIndianRupeeSign,
} from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import profile from "./image/dp.png";
import "./SearchDoctor.css";
import Footer from "../../../Footer/Footer";
import BookingModal from "./BookingModal";
import { getDatabase, ref, get } from "firebase/database";
import { app } from "../../../Doctor/Firebase/firebase.config";
import SpecialityAutosuggest from "../pages/Register/SpecialityAutosuggest";

const database = getDatabase(app);

const normalizeCity = (text = "") => text.toLowerCase().split(",")[0].trim();

const formatTime = (t) => {
  if (!t) return "";
  try {
    const [h, m] = t.split(":").map(Number);
    const ampm = h >= 12 ? "PM" : "AM";
    return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${ampm}`;
  } catch { return t; }
};

const getConsultationFee = (doctor) => {
  const stored = doctor.Fees ?? doctor.fees ?? doctor.Fee ?? doctor.ConsultationFee ?? null;
  if (stored !== null && stored !== undefined && stored !== "") return Number(stored);
  return null;
};

const getCity = (d) => d.Locality || d.City || "";
const getAddress = (d) => d.ClinicAddress || d.Address || "";

/* ── Clinic Photos Modal ── */
function ClinicPhotosModal({ photos, doctorName, onClose }) {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent((c) => (c - 1 + photos.length) % photos.length);
  const next = () => setCurrent((c) => (c + 1) % photos.length);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);

  return (
    <div className="photo-modal-overlay" onClick={onClose}>
      <div className="photo-modal" onClick={(e) => e.stopPropagation()}>
        <div className="photo-modal-header">
          <h3 className="photo-modal-title">
            <FontAwesomeIcon icon={faImages} /> Clinic Photos — Dr. {doctorName}
          </h3>
          <button className="photo-modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="photo-modal-body">
          <div className="photo-main-wrap">
            <button className="photo-nav-btn left" onClick={prev}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <img src={photos[current]} alt={`Clinic photo ${current + 1}`} className="photo-main-img" />
            <button className="photo-nav-btn right" onClick={next}>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          <p className="photo-counter">{current + 1} / {photos.length}</p>
          {photos.length > 1 && (
            <div className="photo-thumbnails">
              {photos.map((src, i) => (
                <img key={i} src={src} alt={`Thumb ${i + 1}`}
                  className={`photo-thumb${i === current ? " active" : ""}`}
                  onClick={() => setCurrent(i)} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ── Timing strip ── */
function TimingStrip({ schedule }) {
  if (!schedule) return (
    <div className="timing-strip">
      <span className="timing-chip no-schedule">
        <FontAwesomeIcon icon={faClock} size="xs" /> Schedule not set
      </span>
    </div>
  );
  const hasMorning = schedule.morningStartTime && schedule.morningEndTime;
  const hasEvening = schedule.eveningStartTime && schedule.eveningEndTime;
  if (!hasMorning && !hasEvening) return (
    <div className="timing-strip">
      <span className="timing-chip no-schedule">
        <FontAwesomeIcon icon={faClock} size="xs" /> Timings not set
      </span>
    </div>
  );
  return (
    <div className="timing-strip">
      {hasMorning && (
        <span className="timing-chip morning">
          <FontAwesomeIcon icon={faSun} size="xs" />
          {formatTime(schedule.morningStartTime)} – {formatTime(schedule.morningEndTime)}
        </span>
      )}
      {hasEvening && (
        <span className="timing-chip evening">
          <FontAwesomeIcon icon={faMoon} size="xs" />
          {formatTime(schedule.eveningStartTime)} – {formatTime(schedule.eveningEndTime)}
        </span>
      )}
    </div>
  );
}

/* ── Doctor Card ── */
function DoctorCard({ doctor, schedule, clinicPhotos = [], rating, onMap, onBook, isMapOpen }) {
  const [expanded, setExpanded] = useState(false);
  const [showPhotosModal, setShowPhotosModal] = useState(false);

  const videoLink = doctor.videoLink || doctor.VideoLink || null;
  const hasPhotos = clinicPhotos.length > 0;
  const hasVideo = !!videoLink;

  const fee = getConsultationFee(doctor);
  const address = getAddress(doctor);

  const handleVideoClick = () => {
    if (hasVideo) window.open(videoLink, "_blank", "noopener,noreferrer");
  };

  const handleChatClick = () => {
    toast.info("💬 Chat with Doctor — Coming Soon!", {
      position: "top-center", autoClose: 3000, hideProgressBar: false,
      style: { fontFamily: "'Nunito', sans-serif", fontWeight: 600 },
    });
  };

  return (
    <div className="doctor-card" style={{ position: "relative" }}>
      <div className="card-top-bar" />

      {rating && rating.count > 0 && (
        <div
          className="rating-badge"
          title={`${rating.average.toFixed(1)} average from ${rating.count} review${rating.count === 1 ? "" : "s"}`}
        >
          <span className="rating-badge-star">⭐</span>
          <span className="rating-badge-score">{rating.average.toFixed(1)}</span>
          <span className="rating-badge-count">({rating.count})</span>
        </div>
      )}

      <div className="card-inner">
        <div className="card-left">
          <img src={doctor.imageUrl || profile} alt={`Dr. ${doctor.First}`} className="doctor-avatar" />
        </div>
        <div className="card-content">
          <div className="doctor-name">Dr. {doctor.First} {doctor.Last}</div>
          <TimingStrip schedule={schedule} />
          <div className="info-list">
            {doctor.Speciality && (
              <div className="info-item">
                <span className="info-label">Speciality</span>
                <span className="info-value">{doctor.Speciality}</span>
              </div>
            )}
            <div className="info-item fee-info-item">
              <span className="info-label">Fees</span>
              <span className="fee-inline">
                {fee !== null ? (
                  <>
                    <FontAwesomeIcon icon={faIndianRupeeSign} className="fee-inline-icon" />
                    <span className="fee-inline-amount">{fee}</span>
                  </>
                ) : (
                  <span className="fee-inline-na">NA</span>
                )}
              </span>
            </div>
            {doctor.Education && (
              <div className="info-item">
                <span className="info-label">Education</span>
                <span className="info-value">{doctor.Education}</span>
              </div>
            )}
            {doctor.Experience && (
              <div className="info-item">
                <span className="info-label">Experience</span>
                <span className="info-value">{doctor.Experience} years</span>
              </div>
            )}
            {doctor.ClinicName && (
              <div className="info-item">
                <span className="info-label">Clinic</span>
                <span className="info-value">{doctor.ClinicName}</span>
              </div>
            )}
            {address && (
              <div className="info-item">
                <span className="info-label">Address</span>
                <span className="info-value">{address}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {doctor.Description && (
        <div className="doctor-description-section">
          <p className={`desc-text${expanded ? " expanded" : ""}`}>{doctor.Description}</p>
          <button className="read-more-btn" onClick={() => setExpanded(!expanded)}>
            <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} size="xs" />
            {expanded ? "Show less" : "Read more"}
          </button>
        </div>
      )}

      <div className="extra-info-row">
        <div className="extra-info-item">
          <span className="extra-info-label">
            <FontAwesomeIcon icon={faImages} className="extra-icon" /> Clinic Photos
          </span>
          {hasPhotos ? (
            <button className="extra-info-action photos-btn" onClick={() => setShowPhotosModal(true)}>
              View Photos ({clinicPhotos.length})
            </button>
          ) : (
            <span className="extra-info-dash">—</span>
          )}
        </div>
        <div className="extra-info-item">
          <span className="extra-info-label">
            <FontAwesomeIcon icon={faVideo} className="extra-icon" /> Video Link
          </span>
          {hasVideo ? (
            <button className="extra-info-action video-btn" onClick={handleVideoClick}>Watch Video</button>
          ) : (
            <span className="extra-info-dash">—</span>
          )}
        </div>
        <div className="extra-info-item">
          <span className="extra-info-label">
            <FontAwesomeIcon icon={faCommentMedical} className="extra-icon" /> Chat
          </span>
          <button className="extra-info-action chat-btn" onClick={handleChatClick}>Chat Soon</button>
        </div>
      </div>

      <div className="card-actions">
        <button className="btn-map" onClick={() => onMap(doctor)}>
          <FontAwesomeIcon icon={faMapMarkerAlt} /> View Map
        </button>
        <button className="btn-book" onClick={() => onBook(doctor)}>
          <FontAwesomeIcon icon={faCalendarAlt} /> Book Appointment
        </button>
      </div>

      {isMapOpen && <div id={`map-${doctor.id}`} className="doctor-map" />}

      {showPhotosModal && hasPhotos && (
        <ClinicPhotosModal
          photos={clinicPhotos}
          doctorName={`${doctor.First} ${doctor.Last}`}
          onClose={() => setShowPhotosModal(false)}
        />
      )}
    </div>
  );
}

/* ── Main ── */
export default function SearchDoctor() {
  const [doctors, setDoctors] = useState([]);
  const [locality, setLocality] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [bookingDoctor, setBookingDoctor] = useState(null);
  const [doctorSchedules, setDoctorSchedules] = useState({});
  const [doctorClinicPhotos, setDoctorClinicPhotos] = useState({});
  const [doctorRatings, setDoctorRatings] = useState({});

  // ── Load Google Maps ──
  useEffect(() => {
    if (window.google?.maps) { setMapLoaded(true); return; }
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&loading=async`;
    s.async = true; s.defer = true;
    s.onload = () => setMapLoaded(true);
    s.onerror = () => toast.error("Google Maps failed to load");
    document.head.appendChild(s);
  }, []);

  // ── Init Places Autocomplete ──
  useEffect(() => {
    if (!mapLoaded) return;
    let retry;
    const init = () => {
      if (window.google?.maps?.places) {
        const input = document.getElementById("locality-input");
        if (!input) return;
        const ac = new window.google.maps.places.Autocomplete(input, {
          types: ["(cities)"], componentRestrictions: { country: "in" },
        });
        ac.addListener("place_changed", () => {
          const p = ac.getPlace();
          setLocality(p.formatted_address || p.name || "");
        });
      } else { retry = setTimeout(init, 100); }
    };
    init();
    return () => clearTimeout(retry);
  }, [mapLoaded]);

  // ── Read URL params from home page search and auto-trigger search ──
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const searchParam = params.get("search") || "";
    const cityParam = params.get("city") || "";

    if (searchParam) setDoctorName(searchParam);
    if (cityParam) setLocality(cityParam);

    if (searchParam || cityParam) {
      setTimeout(() => {
        runSearch(searchParam, cityParam);
      }, 300);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDoctorSchedules = async (ids) => {
    const schedules = {};
    for (const id of ids) {
      try {
        const snap = await get(ref(database, `doctor/${id}/schedule`));
        if (snap.exists()) {
          const data = snap.val();
          const key = Object.keys(data)[0];
          if (key) schedules[id] = data[key];
        }
      } catch (e) { console.error(e); }
    }
    setDoctorSchedules(schedules);
  };

  const fetchDoctorClinicPhotos = async (ids) => {
    const photos = {};
    for (const id of ids) {
      try {
        const snap = await get(ref(database, `Profile/${id}/Clinic`));
        if (snap.exists()) {
          const data = snap.val();
          const images = Array.isArray(data.images) ? data.images : Object.values(data.images || {});
          if (images.length > 0) photos[id] = images.filter(Boolean);
        }
      } catch (e) { console.error(e); }
    }
    setDoctorClinicPhotos(photos);
  };

  // FIX: Node is "reviews" (lowercase), nested as reviews/{doctorId}/{reviewId}/{ rating, ... }
  // So we fetch per-doctor instead of the whole node, and aggregate from the nested reviewId level.
  const fetchDoctorRatings = async (ids) => {
    try {
      const ratings = {};
      for (const id of ids) {
        try {
          const snap = await get(ref(database, `reviews/${id}`));
          if (!snap.exists()) continue;

          const reviewsObj = snap.val();
          // Each value under doctorId can be a direct review object OR
          // another nested level — handle both shapes defensively.
          const reviewList = Object.values(reviewsObj).flatMap((entry) => {
            // If entry itself has a rating field it's a direct review
            if (entry?.rating !== undefined) return [entry];
            // Otherwise it's a nested map of reviews — flatten one more level
            if (typeof entry === "object" && entry !== null) return Object.values(entry);
            return [];
          });

          const valid = reviewList.filter(
            (r) => r?.rating !== undefined && !Number.isNaN(Number(r.rating))
          );
          if (valid.length === 0) continue;

          const sum = valid.reduce((acc, r) => acc + Number(r.rating), 0);
          ratings[id] = { average: sum / valid.length, count: valid.length };
        } catch (e) {
          // Single doctor fetch failed — skip silently, don't abort the loop
          console.warn(`[ratings] Could not fetch reviews for doctor ${id}:`, e.message);
        }
      }
      setDoctorRatings(ratings);
    } catch (e) {
      console.error("Error fetching reviews:", e);
    }
  };

  // ── Core search logic ──
  const runSearch = async (nameOverride, cityOverride) => {
    const searchName = (nameOverride ?? doctorName).trim().toLowerCase();
    const searchCity = normalizeCity(cityOverride ?? locality);
    if (!searchName && !searchCity) {
      toast.warning("Please enter a doctor name or city"); return;
    }
    try {
      setLoading(true); setSearched(true);
      const snap = await get(ref(database, "doctor"));
      if (!snap.exists()) { setDoctors([]); return; }
      const all = Object.entries(snap.val()).map(([id, v]) => ({ id, ...v }));

      const filtered = all.filter((d) => {
        const address = getAddress(d);
        const city = getCity(d);

        const nameMatch = !searchName ||
          String(d.First || "").toLowerCase().includes(searchName) ||
          String(d.Last || "").toLowerCase().includes(searchName) ||
          String(d.Speciality || "").toLowerCase().includes(searchName) ||
          String(d.ClinicName || "").toLowerCase().includes(searchName) ||
          String(address).toLowerCase().includes(searchName);

        const locMatch = !searchCity ||
          normalizeCity(String(city)).includes(searchCity) ||
          String(address).toLowerCase().includes(searchCity);

        return nameMatch && locMatch;
      });

      if (filtered.length) {
        const ids = filtered.map((d) => d.id);
        const profileUrls = {};
        for (const id of ids) {
          try {
            const pSnap = await get(ref(database, `Profile/${id}/Profile/base64`));
            if (pSnap.exists()) profileUrls[id] = pSnap.val();
          } catch (e) { console.error(e); }
        }
        const withPhotos = filtered.map((d) => ({
          ...d,
          imageUrl: profileUrls[d.id] || d.imageUrl || null,
        }));
        setDoctors(withPhotos);
        fetchDoctorSchedules(ids);
        fetchDoctorClinicPhotos(ids);
        fetchDoctorRatings(ids);
      } else {
        setDoctors(filtered);
      }
    } catch (e) {
      console.error(e); toast.error("Failed to fetch doctors");
    } finally { setLoading(false); }
  };

  const fetchDoctors = () => runSearch(doctorName, locality);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") { e.preventDefault(); fetchDoctors(); }
  };

  const handleSpecialitySelect = (name) => {
    setDoctorName(name);
    setTimeout(() => runSearch(name, locality), 0);
  };

  const showDoctorOnMap = (doctor) => {
    if (!mapLoaded) { toast.error("Map still loading"); return; }
    const isAlready = selectedDoctor?.id === doctor.id;
    setSelectedDoctor(isAlready ? null : doctor);
    if (isAlready) return;
    setTimeout(() => {
      const mapDiv = document.getElementById(`map-${doctor.id}`);
      if (!mapDiv) return;
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        { address: `${getAddress(doctor)}, ${getCity(doctor)}` },
        (results, status) => {
          if (status !== "OK" || !results[0]) { toast.error("Location not found"); return; }
          const map = new window.google.maps.Map(mapDiv, { center: results[0].geometry.location, zoom: 15 });
          new window.google.maps.Marker({
            map, position: results[0].geometry.location,
            title: `Dr. ${doctor.First} ${doctor.Last}`,
          });
        }
      );
    }, 150);
  };

  const handleBookAppointment = (doctor) => { setBookingDoctor(doctor); setShowBookingModal(true); };
  const handleCloseBookingModal = () => { setShowBookingModal(false); setBookingDoctor(null); };

  return (
    <>
      <Navbar />
      <Container fluid className="search-doctor-container">
        <ToastContainer position="top-right" autoClose={3000} />

        {/* <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
          <span className="cs-label">
            <span className="cs-star">✦</span>
            Coming Soon
            <span className="cs-star">✦</span>
          </span>
          <p style={{ marginTop: "0.5rem", color: "#64748b", fontSize: "0.88rem" }}>
            More doctors &amp; specialities expanding to your city soon!
          </p>
        </div> */}

        {/* ── Two-block search row ── */}
        <div className="search-row" style={{ position: "relative" }}>

          {/* Block 1 — City with Google Autocomplete */}
          <div className="search-block">
            <label className="search-block-label">
              <FontAwesomeIcon icon={faMapMarkerAlt} /> City
            </label>
            <input
              id="locality-input"
              className="form-control search-block-input"
              type="text"
              placeholder="Enter city..."
              value={locality}
              onChange={(e) => setLocality(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="search-block-divider" />

          {/* Block 2 — Doctor / Speciality */}
          <div className="search-block search-block--flex">
            <label className="search-block-label">
              <FontAwesomeIcon icon={faSearch} /> Doctor / Speciality
            </label>
            <SpecialityAutosuggest
              value={doctorName}
              onChange={(e) => setDoctorName(e.target.value)}
              onSelect={handleSpecialitySelect}
              onSearch={fetchDoctors}
              placeholder="Doctor name, speciality, clinic..."
            />
          </div>

          <button className="search-btn" onClick={fetchDoctors}>
            <FontAwesomeIcon icon={faSearch} /> Search
          </button>
        </div>

        {/* Search row styles */}
        <style>{`
          .search-row {
            display: flex;
            align-items: center;
            background: #fff;
            border: 1.5px solid #d1dff0;
            border-radius: 50px;
            padding: 6px 8px 6px 16px;
            box-shadow: 0 2px 12px rgba(74,144,217,0.10);
            gap: 0;
            max-width: 700px;
            margin: 0 auto 2rem;
          }
          .search-block {
            display: flex;
            flex-direction: column;
            flex: 1;
            min-width: 0;
            padding: 2px 8px;
          }
          .search-block--flex {
            flex: 2;
          }
          .search-block-label {
            font-size: 0.68rem;
            font-weight: 700;
            color: #4a90d9;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            margin-bottom: 2px;
          }
          .search-block-input {
            border: none !important;
            outline: none !important;
            box-shadow: none !important;
            padding: 0 !important;
            font-size: 0.9rem;
            color: #1e293b;
            background: transparent !important;
            height: auto !important;
          }
          .search-block-input::placeholder { color: #94a3b8; }
          .search-block-divider {
            width: 1px;
            height: 36px;
            background: #e2eaf4;
            flex-shrink: 0;
            align-self: center;
          }
          .pac-container { z-index: 99999 !important; }
          .rating-badge {
            position: absolute;
            top: 14px;
            right: 14px;
            display: flex;
            align-items: center;
            gap: 3px;
            background: #fff;
            border: 1px solid #f0d568;
            border-radius: 20px;
            padding: 3px 10px;
            font-size: 0.78rem;
            font-weight: 700;
            color: #1e293b;
            box-shadow: 0 2px 6px rgba(0,0,0,0.08);
            z-index: 2;
          }
          .rating-badge-star { font-size: 0.78rem; line-height: 1; }
          .rating-badge-score { line-height: 1; }
          .rating-badge-count { color: #94a3b8; font-weight: 600; line-height: 1; }
          @media (max-width: 600px) {
            .search-row {
              flex-direction: column;
              border-radius: 16px;
              padding: 12px;
              gap: 8px;
            }
            .search-block-divider { width: 100%; height: 1px; }
            .search-btn { border-radius: 12px !important; width: 100%; justify-content: center; }
            .rating-badge { top: 10px; right: 10px; padding: 2px 8px; font-size: 0.72rem; }
          }
        `}</style>

        {loading ? (
          <p className="status-msg">Looking up doctors…</p>
        ) : searched && doctors.length === 0 ? (
          <div className="coming-soon-banner">
            <p>No doctors found in this area yet. We're expanding — check back soon!</p>
          </div>
        ) : !searched ? (
          <div className="coming-soon-banner">
            <p>Search for doctors by city or speciality above.</p>
          </div>
        ) : (
          <div className="doctors-grid">
            {doctors.map((doctor) => (
              <DoctorCard
                key={doctor.id}
                doctor={doctor}
                schedule={doctorSchedules[doctor.id] || null}
                clinicPhotos={doctorClinicPhotos[doctor.id] || []}
                rating={doctorRatings[doctor.id] || null}
                onMap={showDoctorOnMap}
                onBook={handleBookAppointment}
                isMapOpen={selectedDoctor?.id === doctor.id}
              />
            ))}
          </div>
        )}
      </Container>

      {bookingDoctor && (
        <BookingModal
          show={showBookingModal}
          handleClose={handleCloseBookingModal}
          doctor={bookingDoctor}
        />
      )}
      <Footer />
    </>
  );
}